import React, { useState, useEffect } from 'react';
import { scrapersAPI } from '../services/api';
import { Database, RefreshCw, CheckCircle, Clock } from 'lucide-react';
import toast from 'react-hot-toast';

export default function DataSources() {
  const [sources, setSources] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([scrapersAPI.sources(), scrapersAPI.stats()])
      .then(([srcRes, statsRes]) => {
        setSources(srcRes.data.sources);
        setStats(statsRes.data);
      }).finally(() => setLoading(false));
  }, []);

  const runScraper = async (key) => {
    try {
      await scrapersAPI.run(key);
      toast.success(`Scraper "${key}" triggered`);
    } catch { toast.error('Failed to trigger scraper'); }
  };

  return (
    <div>
      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ fontSize: '26px', marginBottom: '6px' }}>Data Sources</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
          {stats?.active_sources || 0} active sources • Scheduler {stats?.scheduler_running ? 'running' : 'stopped'}
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '28px' }}>
        {[
          { label: 'Total Tenders', value: stats?.total_tenders || 0, color: 'var(--accent-green)' },
          { label: 'Active Sources', value: stats?.active_sources || 0, color: 'var(--accent-blue)' },
          { label: 'Scrapers Available', value: stats?.available_scrapers?.length || 0, color: 'var(--accent-orange)' },
        ].map(({ label, value, color }) => (
          <div key={label} className="card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', fontFamily: 'Syne', fontWeight: '800', color, marginBottom: '6px' }}>{value}</div>
            <div style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>{label}</div>
          </div>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px', color: 'var(--text-muted)' }}>Loading sources...</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {sources.map(source => (
            <div key={source.id} className="card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                  <div style={{ width: '40px', height: '40px', background: 'var(--accent-green-dim)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Database size={18} color="var(--accent-green)" />
                  </div>
                  <div>
                    <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '2px' }}>{source.name}</div>
                    <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{source.url}</div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '16px', fontWeight: '700', color: 'var(--accent-green)' }}>{source.total_tenders_scraped}</div>
                    <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>tenders</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    {source.is_active
                      ? <CheckCircle size={14} color="var(--accent-green)" />
                      : <Clock size={14} color="var(--text-muted)" />}
                    <span style={{ fontSize: '12px', color: source.is_active ? 'var(--accent-green)' : 'var(--text-muted)' }}>
                      {source.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  {source.scraper_key && ['ungm', 'bpp'].includes(source.scraper_key) && (
                    <button className="btn btn-ghost" style={{ padding: '6px 12px', fontSize: '12px' }}
                      onClick={() => runScraper(source.scraper_key)}>
                      <RefreshCw size={12} /> Run
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
